import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

// Model
import { EventTracker } from '../model/google-analytics';

// Services
import { DataService } from './data.service';

// AFS
import { AngularFirestore } from '@angular/fire/firestore';

declare var gtag;

@Injectable({
  	providedIn: 'root'
})
export class AnalyticsService {

  	constructor(
		private http: Http,
		private dataSvc: DataService,
		private afs: AngularFirestore
	) { }

	/**
	 * Calls API to update GA that an event has been fired
	 * @param event information needed for GA to track an event
	 */
	async trackEvent(event: EventTracker): Promise<any> {
		try {
			let headers = new Headers({
				'Content-Type': 'application/json',
				'Authorization' : this.dataSvc.getAuthBearerTokenNoUserNoDaycareAlias(this.afs.createId())
			});
			
			let options = new RequestOptions({ headers });
			let body = JSON.stringify(event);

			let response = await this.http.post(this.dataSvc.getAPIBaseUrl() + "/sendGoogleAnalyticsEvent",body, options)
				.toPromise();

			return response;
		} 
		catch (error) {
			throw error;
		}	
	}

	/**
	 * Send event using gtag, hopefully tracks lead source
	 */
	trackEventGTag(event: EventTracker): void {
		try {
			gtag('event', event.action, {
				'event_category': event.category,
				'event_label': event.label || '',
				'value': event.value || ''
			})
		} catch (e) {
			console.log(e);
		}
	}
}
